<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <slot
        v-bind="attrs"
        v-on="on"
      ></slot>
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    attributs: {
      type: Object
    },
    spantext: {
      type: String,
      default: ""
    }
  }
}
</script>
